import { render, staticRenderFns } from "./transactionChannel.vue?vue&type=template&id=6fa4add8&scoped=true"
import script from "./transactionChannel.vue?vue&type=script&lang=js"
export * from "./transactionChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa4add8",
  null
  
)

export default component.exports